import React from 'react';
import { Card, CardContent } from './ui/card';
import { GraduationCap, FileCheck, Handshake } from 'lucide-react';
import { credibilityData } from '../mockData';

const iconMap = {
  GraduationCap: GraduationCap,
  FileCheck: FileCheck,
  Handshake: Handshake
};

export const CredibilitySection = () => {
  return (
    <section className="relative overflow-hidden">
      {/* Dark section with RCS product image background */}
      <div className="absolute inset-0">
        <img 
          src="https://customer-assets.emergentagent.com/job_38babe41-8d78-47cc-a112-99a9deb87de8/artifacts/1fb0b5bt_RCS%20%26%20Sensor%20Render%2001.png"
          alt=""
          className="w-full h-full object-cover"
        />
        <div className="absolute inset-0 bg-black/65"></div>
      </div>

      <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-24">
        {/* Section Header */}
        <div className="text-center mb-16">
          <h2 className="text-4xl sm:text-5xl font-bold text-white mb-4">
            {credibilityData.headline}
          </h2>
          <div className="w-20 h-1 bg-red-600 mx-auto mb-6"></div>
          <p className="text-xl text-gray-300 max-w-3xl mx-auto">
            Backed by science, protected by patents, validated by industry
          </p>
        </div>

        {/* Credentials Grid */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mb-20">
          {credibilityData.credentials.map((credential) => {
            const IconComponent = iconMap[credential.icon];
            return (
              <Card 
                key={credential.id}
                className="bg-white/10 backdrop-blur-sm border-white/20 hover:border-red-600 hover:bg-white/15 transition-all duration-300 group"
              >
                <CardContent className="p-8 text-center">
                  <div className="w-20 h-20 bg-red-600/20 rounded-full flex items-center justify-center mx-auto mb-6 group-hover:bg-red-600/30 transition-colors duration-300">
                    <IconComponent className="text-red-500" size={40} />
                  </div>
                  <h3 className="text-xl font-bold text-white mb-3">
                    {credential.title}
                  </h3>
                  <p className="text-gray-300 leading-relaxed">
                    {credential.description}
                  </p>
                </CardContent>
              </Card>
            );
          })}
        </div>

      </div>
    </section>
  );
};
